document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("component-carousel")) {
    class Carousel extends HTMLElement {
      constructor() {
        super();
        this.carousel = this.querySelector("[data-carousel]");
        this.offset = 0;
        this.speed = 60; 
        this.lastTime = null;
        this.itemGap = window.innerWidth < 849 ? 10 : 16;

        const originalContent = Array.from(this.carousel.children);
        this.originalWidth = this.carousel.scrollWidth + this.itemGap;
        originalContent.forEach(item => {
          this.carousel.appendChild(item.cloneNode(true));
        });

        this.carousel.style.willChange = 'transform';

        this.animationFrameId = null;
        this.isAnimating = false;
      }

      connectedCallback() {
        this.initCarousel();
        this.checkReduceMotion();
        this.resizeHandler();
      }

      initCarousel() {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.handleIntersect(true);
              } else {
                this.handleIntersect(false);
              }
            });
          },
          { threshold: 0 }
        );
        observer.observe(this);
      }

      handleIntersect = (isIntersecting) => {
        if (isIntersecting && !this.shouldReduceMotion) {
          if (!this.isAnimating) {
            this.isAnimating = true;
            this.lastTime = null;
            this.animationFrameId = requestAnimationFrame(this.animate);
          }
        } else {
          this.isAnimating = false;
          cancelAnimationFrame(this.animationFrameId);
        }
      }

      checkReduceMotion = () => {
        this.shouldReduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;
      }

      animate = (timestamp) => {
        if (!this.lastTime) this.lastTime = timestamp;
        const delta = timestamp - this.lastTime;
        this.lastTime = timestamp;

        this.offset += (this.speed * delta) / 1000; 

        if (this.offset >= this.originalWidth) {
          this.offset = 0;
        }
        this.carousel.style.transform = `translate3d(-${this.offset}px, 0, 0)`;

        if (this.isAnimating) {
          this.animationFrameId = requestAnimationFrame(this.animate);
        }
      };

      resizeHandler = () => {
        const observer = new ResizeObserver(entries => {
          for (let entry of entries) {
            this.itemGap = window.innerWidth < 849 ? 5 : 8;
            this.originalWidth = this.carousel.scrollWidth/2 + this.itemGap;
          }
        });
        observer.observe(this.carousel);
      }

    }
    customElements.define("component-carousel", Carousel);
  }
});